import queryString from 'query-string';

export const getTokenFromUrl = () => queryString.parse(window.location.search).token;
